import React from 'react';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useIdentityChallengeContext } from 'Context/IdentityChallengeContext';
import { useRightSidebarContext } from 'Views/Page/Content/RightSidebar/RightSidebarContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { dispatchRightSidebarUpdated } from 'Hooks/useRefreshEvent';
import { dataAttrs } from 'Helpers/Testing';
import { MetaCollectionRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaCollectionRenderer';


const useStyles = buildUseStyles('RightSidebarForm', (() => ({
  metaFormInline: {
    display: 'flex',
    flexDirection: 'column',
  },
  errorList: {},
})));

const RightSidebarForm = ({
  Layout,
  metaOverrideSet,
  collection,
  LayoutProps,
}) => {
  const classes = useStyles();
  const { handleInterceptResponse } = useIdentityChallengeContext();
  const { setRightSidebarCollection } = useRightSidebarContext();
  const { displayErrorMessage } = useSnackbarContext();

  const onSubmit = async (possiblyDicrsResponse) => {
    return handleInterceptResponse(possiblyDicrsResponse, (originalRequestResponse) => {
      dispatchRightSidebarUpdated();
      setRightSidebarCollection(originalRequestResponse);
      return originalRequestResponse;
    },
    (err) => {
      displayErrorMessage(err, err.errors);
    });
  };

  return (
    <MetaCollectionRenderer
      collection={collection}
      layout={Layout}
      className={classes.metaFormInline}
      metaOverrideSet={metaOverrideSet}
      onSubmit={onSubmit}
      LayoutProps={{
        errorListClassName: classes.errorList,
        ...LayoutProps,
      }}
      {...dataAttrs('right-sidebar-meta-collection-renderer')}
    />
  );
};

RightSidebarForm.defaultProps = {
  metaOverrideSet: null,
};

RightSidebarForm.propTypes = {
  collection: PropTypes.object.isRequired,
  metaOverrideSet: PropTypes.object,
  Layout: PropTypes.object.isRequired,
  LayoutProps: PropTypes.object,
};

export default RightSidebarForm;
